import { FaVolleyballBall, FaBaseballBall } from "react-icons/fa";

import { GiFloorPolisher, GiShuttlecock } from "react-icons/gi";
// Hero Image
import heroImage from "../assets/services/runningtrack/runningtrack.webp";
import overview1 from "../assets/services/runningtrack/overview1.webp";
import overview2 from "../assets/services/runningtrack/overview2.webp";
import overview3 from "../assets/services/runningtrack/overview3.webp";
import overview4 from "../assets/services/runningtrack/overview4.webp";
/* =====================================================
   HERO STATS
===================================================== */

// Gallery Images
import gallery1 from "../assets/services/runningtrack/gallery1.jpg";
import gallery2 from "../assets/services/runningtrack/gallery2.webp";
import gallery3 from "../assets/services/runningtrack/gallery3.webp";
import gallery4 from "../assets/services/runningtrack/gallery4.webp";

const runningTrackData = {
  /* =====================================================
     HERO
  ====================================================== */

  slug: "runningtrack",

  title: "Running Track Construction",

  subtitle: "Professional EPDM Running Track Built to WF Standards",

  heroImage,

  overviewImages: [overview1, overview2, overview3, overview4],

  heroStats: [
    {
      value: "50+",
      label: "Courts Built",
    },

    {
      value: "15+",
      label: "Years Experience",
    },

    {
      value: "WF",
      label: "Certified/Standard",
    },

    {
      value: "2 Yr",
      label: "Warranty",
    },
  ],

  breadcrumb: ["Home", "Services", "Running Track"],

  /* =====================================================
     OVERVIEW
  ====================================================== */

  overview: {
    title: "Professional Running Track Construction",

    description:
      "Quality Sports Surface specializes in designing and constructing international-standard running tracks for schools, universities, sports academies, clubs, residential communities, and professional sports facilities. We use premium polyurethane and EPDM synthetic rubber flooring systems engineered for durability, shock absorption, weather resistance, and maximum athlete performance.",
  },

  /* =====================================================
     BENEFITS
  ====================================================== */

  benefits: [
    {
      title: "WF Standard Construction",
      description:
        "Designed according to international Running track specifications.",
    },

    {
      title: "Premium Polyurethane and EPDM",
      description:
        "High-performance Polyurethane and EPDM Synthetic rubberFlooring with excellent grip and durability.",
    },

    {
      title: "UV & Weather Resistant",
      description:
        "Built to withstand India's harsh climate and heavy rainfall.",
    },

    {
      title: "Low Maintenance",
      description:
        "Minimal maintenance with long-lasting color and surface quality.",
    },
  ],

  /* =====================================================
     CONSTRUCTION PROCESS
  ====================================================== */

  process: [
    {
      step: "01",
      title: "Site Inspection",
      description:
        "Complete site survey, measurements, and technical planning.",
    },

    {
      step: "02",
      title: "Base Preparation",
      description:
        "Concrete or asphalt base preparation with perfect leveling.",
    },

    {
      step: "03",
      title: "Acrylic Coating",
      description:
        "Multiple acrylic layers applied for strength and cushioning.",
    },

    {
      step: "04",
      title: "Court Marking",
      description: "Accurate FIBA-standard basketball court line marking.",
    },

    {
      step: "05",
      title: "Final Inspection",
      description: "Complete quality inspection before project handover.",
    },
  ],

  /* =====================================================
     TECHNICAL SPECIFICATIONS
  ====================================================== */

  specifications: [
    {
      icon: "🏀",
      feature: "Surface Type",
      value: "Premium Polyurethane and EPDM Flooring",
    },

    {
      icon: "🌦",
      feature: "Weather Resistance",
      value: "Excellent",
    },

    {
      icon: "👟",
      feature: "Slip Resistance",
      value: "High Grip Finish",
    },

    {
      icon: "☀",
      feature: "UV Resistant",
      value: "100% UV Stable",
    },

    {
      icon: "🏆",
      feature: "WF Standard",
      value: "International Compliant",
    },

    {
      icon: "⏳",
      feature: "Expected Lifespan",
      value: "10+ Years",
    },

    {
      icon: "🛠",
      feature: "Maintenance",
      value: "Low Maintenance",
    },

    {
      icon: "🌍",
      feature: "Court Type",
      value: "Outdoor",
    },
  ],

  /* =====================================================
   GALLERY SECTION
====================================================== */

  gallerySection: {
    tag: "FEATURED PROJECTS",

    title: "Our Recent Running Track Projects",

    description:
      "Explore some of the premium Running Track successfully completed by Quality Sports Surface across India.",
  },
  /* =====================================================
     GALLERY
  ====================================================== */

  gallery: [
    {
      image: gallery1,
      title: "ABC International School",
      location: "New Delhi",
      surface: "Premium Acrylic Basketball Court",
      year: "2025",
    },

    {
      image: gallery2,
      title: "Academic Heights Public School",
      location: "Hyderabad",
      surface: "Professional EPDM Flooring",
      year: "2026",
    },

    {
      image: gallery3,
      title: "Sports Academy",
      location: "Lucknow",
      surface: "Outdoor Basketball Court",
      year: "2024",
    },

    {
      image: gallery4,
      title: "Academic Height Public School",
      location: "Mallampet, hyderabad",
      surface: "FIBA Standard Court",
      year: "2026",
    },
  ],

  /* =====================================================
   WHY CHOOSE US — RUNNING TRACK
====================================================== */

  whyChoose: {
    tag: "WHY CHOOSE US",

    title: "Why Choose Our Professional Running Track Flooring?",

    description:
      "We provide high-performance running track flooring solutions engineered for athlete safety, consistent traction, shock absorption and long-term durability. From professional-grade materials to precision installation and track finishing, we deliver complete running track solutions for schools, academies, sports complexes and athletic facilities.",

    features: [
      {
        title: "15+ Years Experience",
        description:
          "Over 15 years of experience delivering premium sports flooring and athletic surface solutions for schools, universities, academies, clubs and sports facilities across India.",
      },

      {
        title: "100+ Sports Projects",
        description:
          "Successfully completed 100+ sports infrastructure and flooring projects, including running tracks, athletic facilities, sports complexes, schools and training centres.",
      },

      {
        title: "Premium Track Materials",
        description:
          "We use high-quality sports-grade materials selected for durability, weather resistance, traction, flexibility and reliable performance under demanding athletic conditions.",
      },

      {
        title: "Superior Shock Absorption",
        description:
          "Our running track systems are designed to provide controlled impact absorption, helping reduce stress on athletes' feet, ankles, knees and joints during repetitive running activity.",
      },

      {
        title: "Excellent Traction & Grip",
        description:
          "Professionally installed track surfaces provide consistent traction and grip, helping athletes maintain stability during sprinting, acceleration, cornering and high-speed movement.",
      },

      {
        title: "Consistent Running Surface",
        description:
          "Precision installation helps create a smooth, uniform and reliable surface that supports consistent stride, speed and athlete performance across the track.",
      },

      {
        title: "All-Weather Performance",
        description:
          "Our outdoor track solutions are designed to withstand demanding environmental conditions while maintaining surface performance, durability and reliable traction.",
      },

      {
        title: "Professional Track Marking",
        description:
          "We provide accurate lane markings, start and finish lines, event markings and other track graphics to create a clean and professional athletic facility.",
      },

      {
        title: "Durable & Long-Lasting",
        description:
          "High-quality materials and professional installation help the track withstand regular training, competitions and continuous athlete usage while maintaining its performance.",
      },

      {
        title: "Custom Track Solutions",
        description:
          "We provide customized running track solutions based on track dimensions, facility requirements, usage intensity, existing surface conditions, design preferences and project budget.",
      },

      {
        title: "Professional Installation Team",
        description:
          "Our experienced team manages surface preparation, base work, track installation, finishing and line marking with careful attention to gradients, surface consistency and overall quality.",
      },

      {
        title: "On-Time Project Delivery",
        description:
          "Our structured project management process ensures efficient execution and helps complete running track projects within committed timelines with minimal disruption to your facility.",
      },

      {
        title: "Complete Project Support",
        description:
          "From initial consultation and site assessment to surface installation, track marking, maintenance guidance and after-sales assistance, we provide complete project support.",
      },

      {
        title: "Maintenance & After-Sales Support",
        description:
          "We provide practical maintenance recommendations and ongoing support to help preserve the track's surface quality, traction, appearance and long-term performance.",
      },
    ],
  },

  /* =====================================================
     FAQ
  ====================================================== */

  faqs: [
    {
      question:
        "What is the best surface material for a professional running track?",
      answer:
        "Polyurethane-bound rubber(polyurethane running tracks) offers the best durability, shock absorpton, and weather resistance. Porous rubber-crumb systems are excellent budget-friendly alternatives",
    },

    {
      question: "How many lanes does a standard athletic track require?",
      answer:
        "Standard competition tracks require 8 to 9 lanes, each exactly 1.22 meters wide. High Schools or community parks can usse 4 to 6 lanes to fit limmited spaces.",
    },

    {
      question: "What type of base layer is required before pouring the track?",
      answer:
        "Tracks require a stable 150-200mm crushed stones base topped with 40-50mm of asphalt. The asphalt must cure completely to prevent surface bubbling.",
    },

    {
      question:
        "How long does a synthetic running track last before needing resurfacing?",
      answer:
        "A high-quality track lasts 2 to 5 years with proper maintenance. Heavy use, UV exposure, and drainage issues can shorten this lifespan.",
    },
  ],

  /* =====================================================
       RELATED SERVICES
    ====================================================== */

  relatedServices: [
    {
      icon: GiFloorPolisher,
      title: "Wooden-flooring",
      description: "Professional MFMA Standard Courts",
      link: "/services/wooden-flooring",
    },

    {
      icon: GiShuttlecock,
      title: "Badminton Court",
      description: "Professional BWF Standard Courts",
      link: "/services/badminton-court",
    },

    {
      icon: FaBaseballBall,
      title: "Basketball Court",
      description: "Professional FIBA Standard Courts",
      link: "/services/basketball-court",
    },

    {
      icon: FaVolleyballBall,
      title: "Volleyball Court",
      description: "Professional FIVB Standard Courts",
      link: "/services/volleyball-court",
    },
  ],
  /* =====================================================
     CTA
  ====================================================== */

  cta: {
    title: "Ready to Build Your Running Track?",

    description:
      "Talk with our experts today and get a free consultation for your next sports infrastructure project.",
  },
};

export default runningTrackData;
